import React, { useState } from 'react';
import { Menu, Dropdown } from 'antd';

import styles from './index.module.scss';
import defaultAvatar from 'asset/image/me_avatar_default@2x.png';
import { useDispatch, useSelector } from 'react-redux';
import { loginOut } from 'model/login';
import { useHistory } from 'react-router';
import APP_ROUTE from 'constant/route';
import { RootState } from 'model';
import FridayTracker from '@cvte/react-fridayagent3';
import FRIDAYAGENT_EVENTS from 'constant/fridayAgentEvent';
import ModifyPasswordModal from './ModifyPassword/ModifyPasswordModal';
import ModifyPasswordPriv from './ModifyPasswordPriv/ModifyPasswordModal';
import WithPrivateCheck from 'component/WithPrivateCheck';
import tracker from 'lib/tracker';

interface AvatarMenuProps {
  onClick: () => void;
  switchClick: () => void;
  modifyPasswordClick: () => void;
}
const AvatarMenu: React.FC<AvatarMenuProps> = ({ onClick, switchClick, modifyPasswordClick, ...props }) => {
  return (
    <Menu {...props}>
      <Menu.Item onClick={switchClick}>
        <FridayTracker {...FRIDAYAGENT_EVENTS.WEB_TAMES_CLICK_NAV_SWITCH}>切换企业</FridayTracker>
      </Menu.Item>
      <Menu.Divider />
      <Menu.Item onClick={modifyPasswordClick}>设置密码</Menu.Item>
      <Menu.Divider />
      <Menu.Item onClick={onClick}>退出登录</Menu.Item>
    </Menu>
  );
};

interface IProps {}

const More: React.FC<IProps> = () => {
  const useInfo = useSelector((state: RootState) => state.user.userInfo);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const dispatch = useDispatch();
  const history = useHistory();
  const onClick = () => {
    tracker?.reporteWebMenuView('退出登录');
    dispatch(loginOut());
    const checkElement = () => {
      const difyBox = document.getElementById('dify-chatbot-bubble-button');
      console.log(difyBox, 'DifyChatbot');
      if (difyBox) {
        // 为元素添加属性，例如添加自定义属性
        difyBox.style.display = 'none';
      } else {
        // 如果元素还不存在，设置一个短时间后再次检查
        setTimeout(checkElement, 100);
      }
    };
    checkElement();
  };
  const switchClick = () => {
    history.push(APP_ROUTE.SWICH);
    tracker?.reporteWebMenuView('切换企业');
  };

  const closeModifyPasswordModal = () => {
    setIsModalVisible(false);
  };

  const showModifyPasswordModal = () => {
    setIsModalVisible(true);
    tracker?.reporteWebMenuView('设置密码');
  };
  return (
    <>
      <Dropdown overlay={<AvatarMenu onClick={onClick} switchClick={switchClick} modifyPasswordClick={showModifyPasswordModal} />}>
        <img className={styles.avatar} src={useInfo?.avatar || defaultAvatar} alt="avatar" />
      </Dropdown>
      <WithPrivateCheck>
        <ModifyPasswordPriv show={isModalVisible} onClose={closeModifyPasswordModal} />
      </WithPrivateCheck>
      <WithPrivateCheck hide>
        <ModifyPasswordModal show={isModalVisible} onClose={closeModifyPasswordModal} />
      </WithPrivateCheck>
    </>
  );
};

export default More;
